/**
 * @file   src\Pages\ManageHardware.tsx
 * @brief  Manage Hardware page.
 * @date   SEP, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React, { useEffect, useState } from 'react';
import { Container, Button, useNavigate, useOutletContext } from '../utils/thirdpartyComponents';
import AddIcon from '../assets/images/icons/addicon';
import Deviceicon from '../assets/images/computer-chip.svg';
import { pageURLs } from '../utils/pageUrls';
import { AppContextType } from '../interfaces/generalInterface';
import axios from '../config/axiosConfig';
import { ManageHardwareApi } from '../utils/apiUrls';
import SmallLoader from '../components/SmallLoader';



const ManageHardware = () => {
  const navigate = useNavigate();
  const [hardwareList,setHardwareList] = useState([]);
  const [loading, setLoading] = useState(true);
      // Access the context
    const { data, updateData } = useOutletContext<AppContextType>();
   // Update the data
   const handleUpdate = async () => {
    await updateData({ heading:  "Manage Hardware" , url: `/superadmin/${pageURLs.manage_hardware}`, showBackButton:  false , showMainMenu: true, activeLink: "manage-hardware"  });
};

useEffect(()=>{
    handleUpdate()
    getHardwareList()
},[])


    // Function to fetch Hardware List
    const getHardwareList = async () => {
      try {
          setLoading(true)
          const { data } = await axios.get(ManageHardwareApi.LIST_HARDWARE);
          setLoading(false)
          if (data?.error === 0 ) {
            setHardwareList(data.data)
          } else {
            setHardwareList([])
          }
      } catch (error: any) {
          console.error('Error fetching company information:', error.message);
          throw new Error(error.response?.data?.message || error.message);
      }
  };



  return (
    <div className="hardware-listing-container">
      <Container>
        <div className="button-group-header d-flex justify-content-end">
          <Button
            title="Order List"
            variant="secondary"
            className="secondary-btn"
            onClick={() => navigate("/superadmin/" + pageURLs.order_list)}
          >
            Order List
          </Button>
          {/* <Button title="Track Orders" variant="secondary" className="secondary-btn" onClick={()=>navigate("/superadmin/"+pageURLs.track_orders)}>
            Track Orders
          </Button> */}
          <Button title="Marketing Package" variant="secondary" className="secondary-btn" onClick={()=>navigate("/superadmin/"+pageURLs.marketing_package)}>
            Marketing Package
          </Button>
          <Button
            type="submit"
            title="Add New Item"
            variant="primary"
            className="primary-btn d-flex align-items-center add-btn"
            onClick={()=>{navigate("/superadmin/"+pageURLs.addnew_hardware)}}
          >
            Add New Item
            <AddIcon />
          </Button>
        </div>

        <h6 className="f-bold title">Manage Hardware </h6>

        <div className="hardware-list-wrap">
          <div className="device-list-group d-flex justify-content-center mx-auto">
            {(hardwareList).length > 0 ? hardwareList.map((item:any) => (
              <div key={item?.id} className="product-card text-center">
                <div className="device-frame device-img d-flex align-items-center justify-content-center">
                  <img  src={item.image ? `${process.env.REACT_APP_S3_URL_PUBLIC_PATH || ""}${item.image}` : Deviceicon} alt={item.name} />
                </div>
                <h5 className="f-bold">{item.name}</h5>
                <h2 className="f-bold">${item.price}</h2>
                <p className="f-medium">{item.description}</p>
                <Button title="Edit" variant="primary" className="primary-btn"  onClick={()=>{navigate("/superadmin/"+pageURLs.edit_hardware+"/"+item.hardwareId)}}>
                  Edit
                </Button>
              </div>
            )):
            (
              
                <div>No data found.</div>
              
            )}
          </div>
        </div>
      </Container>
      {loading && <SmallLoader />}
    </div>
  );
};

export default ManageHardware;
